import React from "react";

const LinkArrow = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.18166 0.183617C5.23972 0.125413 5.30869 0.0792341 5.38462 0.047726C5.46055 0.016218 5.54195 0 5.62416 0C5.70637 0 5.78777 0.016218 5.86371 0.047726C5.93964 0.0792341 6.00861 0.125413 6.06666 0.183617L9.81666 3.93362C9.87487 3.99167 9.92105 4.06064 9.95255 4.13657C9.98406 4.21251 10.0003 4.29391 10.0003 4.37612C10.0003 4.45833 9.98406 4.53973 9.95255 4.61566C9.92105 4.69159 9.87487 4.76056 9.81666 4.81862L6.06666 8.56862C5.94931 8.68597 5.79013 8.75191 5.62416 8.75191C5.45819 8.75191 5.29902 8.68597 5.18166 8.56862C5.06431 8.45126 4.99837 8.29209 4.99837 8.12612C4.99837 7.96015 5.06431 7.80097 5.18166 7.68362L8.49041 4.37612L5.18166 1.06862C5.12346 1.01056 5.07728 0.94159 5.04577 0.865659C5.01427 0.789728 4.99805 0.708326 4.99805 0.626117C4.99805 0.543908 5.01427 0.462506 5.04577 0.386575C5.07728 0.310643 5.12346 0.241674 5.18166 0.183617Z"
        fill="#5FB2B4"
      />
      <path
        d="M0 4.37598C0 4.21022 0.0658481 4.05125 0.183058 3.93403C0.300269 3.81682 0.45924 3.75098 0.625 3.75098H8.75C8.91576 3.75098 9.07473 3.81682 9.19194 3.93403C9.30915 4.05125 9.375 4.21022 9.375 4.37598C9.375 4.54174 9.30915 4.70071 9.19194 4.81792C9.07473 4.93513 8.91576 5.00098 8.75 5.00098H0.625C0.45924 5.00098 0.300269 4.93513 0.183058 4.81792C0.0658481 4.70071 0 4.54174 0 4.37598Z"
        fill="#5FB2B4"
      />
    </svg>
  );
};

export default LinkArrow;
